import { Routes, RouterModule } from "@angular/router";
import { Pages } from "./pages.component";
import { ModuleWithProviders } from "@angular/core";
// noinspection TypeScriptValidateTypes

// export function loadChildren(path) { return System.import(path); };

export const routes: Routes = [
  {
    path: "login",
    loadChildren: "app/pages/login/login.module#LoginModule"
  },
  {
    path: "register",
    loadChildren: "app/pages/register/register.module#RegisterModule"
  },
  {
    path: "pages",
    component: Pages,
    children: [
      { path: "", redirectTo: "home", pathMatch: "full" },
      { path: "home", loadChildren: "./home/home.module#HomeModule" },
      {
        path: "personal",
        loadChildren: "./personal/personal.module#PersonalModule"
      },
      {
        path: "registerHours",
        loadChildren:
          "./adminSurveyPlans/adminSurveyPlans.module#AdminSurveyPlansModule"
      },
      { path: "labor", loadChildren: "./labor/labor.module#LaborModule" },
      {
        path: "laborView/:laborId",
        loadChildren: "./laborView/laborView.module#LaborViewModule"
      },
      {
        path: "editPersonal/:personalId",
        loadChildren: "./editPersonal/editPersonal.module#EditPersonalModule",
        data: { personal_data: "personal" }
      },
      {
        path: "editHours/:hourlId",
        loadChildren: "./generalConfig/generalConfig.module#GeneralConfigModule"
      },
      { path: "user", loadChildren: "./user/user.module#UserModule" },
      {
        path: "jornadasPendientes",
        loadChildren: "./jornadasPendientes/jornadasPendientes.module#JornadasPendientesModule"
      },
      {
        path: "fichajesSinPersona",
        loadChildren: "./fichajesSinPersona/fichajesSinPersona.module#FichajesSinPersonaModule"
      },
      {
        path: "fichajesARevisar",
        loadChildren: "./fichajesARevisar/fichajesARevisar.module#FichajesARevisarModule"
      }
    ]
  }
];

export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// /app/src/app/pages/pages.routing.ts